import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom'; // Import the useLocation hook
import NavBar from './NavBar';
import Sidebar from './SideBar';
import AccountsIcon from '../../../assets/images/accounts.png';
import BreadCrumbs from '../../CustomComponents/BreadCrumbs';
import Footer from '../Footer';
import { CAN_CREATE_SAVINGS_ACC, GET_NOTIFICATIONS, PAID_PROMO_KEY, STATUS_SUCCESS_CODE } from '../../../network/URLConstants';
import { GetApiHeadersWithBearer, GetRequest } from '../../../network/NetworkUtils';
import { retrieveData } from '../../../utils';
import { useOidcAccessToken } from '@axa-fr/react-oidc';
import { useTranslation } from 'react-i18next';
import Loader from '../../CustomComponents/Loader';
import { useDispatch, useSelector } from 'react-redux';
import beneficiarysaving from '../../../assets/images/beneficiarysaving.png';
import CustomAlertModel from '../../CustomComponents/CustomAlertModel';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { appTheme } from '../../../helpers/utils/Utils';
import CustomModalPlus from '../../../kudzu_plus/helpers/customModalPlus';
import Cookies from 'js-cookie';
import MembershipBanner from '../../Banner/Banner';
import { CHECKING_CARD_CODE } from '../../../helpers/utils/Utils';
import Modal from "components/CustomComponents/Modal";
import Dollor_Tick from '../../../assets/images/success.png'
import smiErrorImg from '../../../assets/smi-kudzu-images/smi_mobile_error.png'
import { PostRequest } from '../../../network/NetworkUtils';
import { selectHasKudzuCard } from '../../../Redux/selectors';

// Add this style block for mobile-only margin
const navbarBannerMobileStyle = `
  @media (max-width: 640px) {
    .navbar-with-banner-mobile { margin-top: 48px !important; transition: margin-top 0.3s; }
  }
  @media (min-width: 641px) {
    .navbar-with-banner-mobile { margin-top: 0 !important; }
  }
`;


const HomeLayout = ({ children, showBanner, handleExploreClick, handleBannerCloseClick, hideSidebar }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [animationPlayed, setAnimationPlayed] = useState(false);
  const isAcceptAgreement = useSelector(state => state.isAcceptAgreement)




  const [isLoading, setIsLoading] = useState(false);
  const alertsObj = useSelector(state => state.userAlerts);
  const notificationUnreadCount = useSelector(state => state.notificationUnreadCount);
  const { accessToken } = useOidcAccessToken()


  const savingsCardAvailable = useSelector(state => state.savingsAccontAvailable);


  const HighlightMsgStyles = "sm:w-auto w-[253px] font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal text-[#2965FB] cursor-pointer pointer-events-none";
  const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
  const SubHeaderMsgStyles = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none text-[var(--modal-text-heading-clr)]";
  const HeaderMsgStylesForPlus = "font-serif-pro modal-title text-white lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-[400] cursor-pointer pointer-events-none";
  const summaryParagraphStyles = "font-hanken-grotesk modal-title text-white lg:text-[13px] md:text-[10px] sm:text-[6px] text-[8px] font-[200] cursor-pointer pointer-events-none";
  const [highlightMsg, setHighlightMsg] = useState('')
  const [headerMsg, setheaderMsg] = useState('')
  const [subHeaderMsg, setSubHeaderMsg] = useState('')
  const [btn1Exists, setBtn1Exists] = useState(false)
  const [btn2Exists, setBtn2Exists] = useState(false)
  const [btn1Text, setBtn1Text] = useState(false)
  const [btn2Text, setBtn2Text] = useState('')
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
  const [footerMsg, setFooterMsg] = useState('');
  const [showModel, setShowModel] = useState(false);
  const [modelImage, setModelImage] = useState('')
  const [savingsTheme, setSavingsTheme] = useState(false);
  const [isBorderNone, setisBorderNone] = useState(true);
  const [isSubFooter, setIsSubFooter] = useState(false);
  const [btn1BgColor, setBtn1BgColor] = useState("");
  const [carousel, setCarousel] = useState('');
  const [opacityValueLow, setOpacityValueLow] = useState(false);
  const [summaryParagraph, setSummaryParagraph] = useState('');
  const [gradientButton, setGradientButton] = useState(false);
  const [largeImage, setLargeImage] = useState(false);
  const [showPlusModal, setShowPlusModal] = useState(false);
  const [fullWidth, setFullWidth] = useState(false);
  const [footerButtonEnable, setFooterButtonEnable] = useState(false);
  const [comparisonScreen, setComparisonScreen] = useState('');
  const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));


  const [promoKey, setPromoKey] = useState(loggedResponse?.Promos?.[0]?.PromoKey);
  const smiOneTrue = useSelector((state) => state?.smiOneAccountTrue);
 
 






  const cards = useSelector(state => JSON.parse(state.userCards));
  const hasKudzuCard = useSelector(selectHasKudzuCard);
  const accessTokenToApi = useSelector(state => state.accessToken);
   const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue);


      
    
  const HeadingStyles =
    "font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-highlight)]";
  const HeadingUpdatedStyles =
    "font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-heading-clr)]"
  const continueButtonClasses = `font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[13px] text-[14px] text-[#2965FB] cursor-pointer  flex items-center`;

  const [activityDetected, setActivityDetected] = useState(false)
  const [displayErrorMessage, setDiplayErrorMessage] = useState('')
  const [displaySuccessMesg, setDisplaySuccessMsg] = useState('')
  const [errorModal, setErrorModal] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)

  const closeActivityDetectedModal = () => {
    setActivityDetected(false)
  }

  const closeErorModal = () => {
    setErrorModal(false)
  }

  const backToHome = () => {
     setActivityDetected(false)
  }

   const backToHomeError = () => {
     setErrorModal(false)
  }

  const handleNotificationAction = async (callbackUrl) => {
    try {
      setIsLoading(true);
      const deviceId = await retrieveData('updatedDeviceId');
      const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
      const response = await PostRequest(callbackUrl, {}, headers);
      const responseJson = JSON.parse(response);
      if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
        setIsLoading(false);
        setDisplaySuccessMsg(responseJson.Response.message)
        setIsSuccess(responseJson.Response.isSuccess)
        setActivityDetected(true);
        fetchNotifications(true, true);
      } else {

        setIsLoading(false);
        setErrorModal(true);
        var arrMessages = responseJson.Messages;
        var message = arrMessages[0];
        var displayText = message.DisplayText;
        setDiplayErrorMessage(displayText)
      }
    } catch (error) {
      setIsLoading(false);
    }
  }
       
    




  const fetchNotifications = async (isRead, isUnread) => {
    if (cards == null || cards == undefined) {
      return
    }
    try {
      setIsLoading(true);
      const deviceId = await retrieveData('updatedDeviceId')
      const cardKey = cards !== null
        ? cards?.find(item =>
          item.ProgramKey === (hasKudzuCard ? 200 : 112) &&
          item.AccountTypeBit63 === (hasKudzuCard ? 64 : 1)
        )?.CardKey
        : 0;
      const rowsPerPage = 4;
      const page = 1;


      const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
      const url = GET_NOTIFICATIONS(cardKey, isRead, isUnread, rowsPerPage, page, true)
      const response = await GetRequest(url, headers);
      const responseJson = await JSON.parse(response);
      setIsLoading(false);
      if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {


        setIsLoading(false);
        dispatch({ type: 'USER_ALERTS', payload: { 'userAlerts': responseJson.Response } })
        // setAlertsObj(responseJson.Response);


      }


    } catch (error) {
      setIsLoading(false);
    }
  }


  useEffect(() => {
    //get top 4 notifications
    fetchNotifications(false, true);
    // if(isAcceptAgreement) fetchNotifications(false, true);
  }, [notificationUnreadCount])


  const canCreateSavingsAccount = async () => {
    const deviceId = await retrieveData('updatedDeviceId');
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    setIsLoading(true)


    let finalUrl = CAN_CREATE_SAVINGS_ACC(cards[0].CardKey)
    var response = await GetRequest(finalUrl, headers)
    var responseObj = JSON.parse(response)
    setIsLoading(false)
    if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
        const canCreateNew = responseObj.Response.canCreateNew
        const eligibleDate = moment(responseObj.Response.eligibleDate).format('MM/DD/YYYY')
        if (canCreateNew) {
          enrollSavingsAccount()
        } else {
            showAlertModal(true, t("oh_no"), t('unable_to_open'), `${t('u_will_be_eligible')} ${eligibleDate}. `, true, false, t('home'), '', true, require('../../../assets/images/illo-report.png'), false, false, true)
        }
    } else {
        setTimeout(() => {
            var arrMessages = responseObj.Messages;
            var message = arrMessages[0];
            var displayText = message.DisplayText;
            showAlertModal(true, t("oh_no"), <p className={`${kudzuPlusTrue ? 'text-white' : ''}`}>{displayText}</p>, '', true, false, t('home'), '', true, require('../../../assets/images/illo-report.png'), false, false)


            // setError(displayText)
        }, 500);
    }
}


const subComponent = () => {
  return (
      <div className=' flex justify-start items-start'>
          <p className="font-hanken-grotesk font-semibold sm:font-[500] sm:text-[14px] md:text-[20px] text-[16px] md:leading-[30px] leading-[24px]">{t("pl_contact_customer")}<span className="text-[#2965FB] cursor-pointer" onClick={
              () => window.open("https://www.kudzumoney.com/contact-us", '_blank')}>{t("support_email")}</span>{t("for_access")}</p>
      </div>
  )
}


  const enrollSavingsAccount = () => {
    debugger;
    // const savingsNewPayload = { savingsNewClicked: true };
    // dispatch({ type: 'SAVINSGS_DISABLED', payload: savingsNewPayload });
     const newbadgeValue = `newbadge${cards[0].CardKey}`;
      Cookies.set(newbadgeValue, true, { expires: 1825 });
    if(kudzuPlusTrue){
          showAlertModalPlus(true,"" ,
                promoKey == PAID_PROMO_KEY ? t("Get_1.25%_APY_on_an_optional_savings_account_with_trial") : t('Get_1.25%_APY_on_an_optional_savings_account'),
                "", true, true,  t("enroll"),  t("may_be_later"), true, require('../../../assets/kudzu-plus-images/Benificiary.png'), "", true, "#262B3A",
                '',
                true, '', false, false, true, true);
    }
    else{
    showAlertModal(true, '', t('set_aside_money_for_the_things_that_matter'), t('add_savings_account_subTitle'), true, true, t('enroll'), t('may_be_later'), true,beneficiarysaving, true, true);
    }
  }


  const handleSidebarToggle = (isSidebarOpen) => {
    setIsSidebarOpen(isSidebarOpen);
    dispatch({type: "SIDE_BAR_OPEN", payload:{isSideBarOpen: isSidebarOpen}})
  };


  const closeSideMenu = () => {
    setIsSidebarOpen(false);
    dispatch({type: "SIDE_BAR_OPEN", payload:{isSideBarOpen: false}})
  };


  // Get the current location
  const location = useLocation();
  const breadcrumbPaths = ['/AccountServices', '/Settings', '/Help', '/CardServices', '/PersonalInformation', '/Documents', '/Security', '/Toolkit', '/ToolkitMenu'];


  // Check if the current path includes "/Settings/notificationConfigure"
  const isNotificationConfigurePage = location.pathname.toLowerCase().includes('/settings/notificationconfigure');
  // Check if the current path matches any of the breadcrumb paths
  const isAccountServicesPage = breadcrumbPaths.some(path => location.pathname.includes(path));


  const closeCustomAlertModal = () => {


    setShowModel(false);
  }


  const onAcptBtnClick = async () => {
    setShowModel(false)
    if (btn1Text == t("enroll")) {
      navigate('/SetupSavingsAccount')
      dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('account_services_savings_enrollment') } });
    }else if (btn1Text == t('home')) {
      navigate('/home')
    }
  }
  const onCancelBtnClick = () => {
    setShowModel(false)
    showAlertModal(true, '', t('savings_no_problem_title'), t('via_account_services_title'), true, false, t('okay_got_it'), '', true, beneficiarysaving, true, true);


  }
  //                      (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, footerMsg, showErrorImg, isBorderNone, btn1Focus, btn2Focus)
  const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, savingsTheme, isBorderNone, isSubFooter) => {
    setShowModel(showModel)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
    setSavingsTheme(savingsTheme)
    setisBorderNone(isBorderNone)
    setIsSubFooter(isSubFooter)


  }


  const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor, summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable, gradientButton, largeImage) => {
    setShowPlusModal(showPlusModal)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
    setBtn1Exists(btn1Exists)
    setBtn1Text(btn1Text)
    setCarousel(carousel)
    setisBorderNone(isBorderNone)
    setBtn1BgColor(btn1BgColor)
    setSummaryParagraph(summaryParagraph)
    setOpacityValueLow(opacityValue)
    setComparisonScreen(comparisonScreen)
    setFullWidth(fullWidth)
    setFooterButtonEnable(footerButtonEnable)
    setGradientButton(gradientButton)// gradient button for popup
    setLargeImage(largeImage)
  }




  const onAcptBtnClickPlusModal = () =>{
    if (btn1Text == t("enroll")) {
      navigate('/SetupSavingsAccount')
      dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('account_services_savings_enrollment') } });
    }
  }
  const onCancelBtnClickPlusModal = () =>{
    setShowPlusModal(false)
    showAlertModal(true, '',<p><span className='text-[var(--enroll-maybelater-hilight)]'>{t('no_problem_exclimation')}</span><span>{" "}</span>{t('You_may_add_a_Kudzu_SavingsAc_count_at_any_time')}</p>, t('via_account_services_title'), true, false, t('okay_got_it'), '', true, appThemeData.cell, true, true);
  }
  const closeModelPlus = () =>{
    setShowPlusModal(false)
  }






  return (
    <>
      <style>{navbarBannerMobileStyle}</style>
      {/* Membership Banner at the top if visible */}
      {kudzuPlusTrue &&
        <>
          {showBanner && hasKudzuCard &&(
            <MembershipBanner
              handleExploreClick={handleExploreClick}
              handleCloseClick={handleBannerCloseClick}
            />
          )}
        </>}
      {/* NavBar with margin-top on mobile if banner is visible */}
      <div
        className={`w-full z-40${showBanner ? ' navbar-with-banner-mobile' : ''}`}
      >
        { !hideSidebar &&<NavBar
          savingEnrollClicked={canCreateSavingsAccount}
          isSidebarOpen={isSidebarOpen}
          handleSidebarToggle={handleSidebarToggle}
          unreadCount={alertsObj?.UnreadCount || 0}
          ReferralLogoUri={cards?.[0]?.ReferralLogoUri}
          SidebarOpen={isSidebarOpen}
        />}
      </div>
      {/* Sidebar */}


      {!hideSidebar && <div className={`flex fixed  ${smiOneTrue ? 'md:w-[18rem]' : 'md:w-[17rem]' } sm:w-[15rem] w-screen top-0 z-50 transition-all duration-1000 ${!isSidebarOpen ? ' sm:right-[-18rem] right-[-35rem] ' : 'right-0'}`}>
        <Sidebar closeSidebar={() => { closeSideMenu() }}
          notifications={alertsObj?.Alerts?.Items || []}
          onAction={handleNotificationAction} />
      </div>}


      {/* {(isSidebarOpen && alertsObj) &&
      <Sidebar closeSidebar={() => { closeSideMenu() }}
        notifications={alertsObj?.Alerts.Items}


        className='transition-all duration-1000 ' />} */}


      {/* Conditional Rendering of Breadcrumbs */}
      {isAccountServicesPage  && <BreadCrumbs />}


      <div className="scrollable-container-home loaded">
        <div className="overflow-x-hidden">
          <div className={` px-0 sm:py-10 sm:px-[6%] py-2 flex flex-wrap sm:flex-nowrap first-letter:px-4 pt-0 relative
         transition-all duration-1000 right-0 sm:px-[6%]`}>
            {/* <div className={`sm:px-[6%] px-0 sm:py-10 py-2 flex flex-wrap sm:flex-nowrap first-letter:px-4 pt-0 relative
         transition-all duration-1000 ${isSidebarOpen ? 'md:right-[23rem] sm:right-[13rem] right-[30rem]' : 'right-0'}`}> */}
            {/* ///////All content of the page will be here//////// */}
            {children}
            {/* ///////All content of the page will be here//////// */}
          </div>
          {/* <div className={`flex-1 transition-all duration-1000 ${isSidebarOpen ? 'md:ml-[-80rem] ml-[-40rem]': 'ml-0'}`}> */}
          <div className="flex-1 transition-all duration-1000 ml-0'">
            <Footer />
          </div>


        </div>
      </div>
      <CustomAlertModel isOpen={showModel}
        onClose={closeCustomAlertModal}
        image={modelImage}
        modalBg={!isSubFooter && 'bg-[var(--text-bg-subway)]'}
        btn1BorderColor={!isSubFooter && '#30BC89'}
        btn1TextColor={!isSubFooter && '#FEFAEE'}
        btn1BrExist={!isSubFooter && kudzuPlusTrue ? false : true}
        btn2TextColor={'#559C7E'}
        btn1BgColor={!isSubFooter && kudzuPlusTrue ? "" : '#30BC89'}
        highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg}
          <span className={`${HeaderMsgStyles} ${savingsTheme ? 'text-[var(--text-clr-secondary6)]' : 'text-black'}`}> {headerMsg}</span></p>}
        // highlightMsg={<p className={HighlightMsgStyles}>{highlightMsg}</p>}
        // HeaderMsg={<p className={HeaderMsgStyles}>{headerMsg}</p>}
        subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
        btn1Exists={btn1Exists}
        btn2Exists={btn2Exists}
        btn1Text={btn1Text} btn2Text={btn2Text}
        btn1TypeAcpt={btn1TypeAcpt}
        verificationFailure={() => { }}
        footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
        onAcptBtnClick={onAcptBtnClick}
        onCancelBtnClick={onCancelBtnClick}
        isBorderNone={isBorderNone}
        subFooter={isSubFooter && subComponent()}
      />
       <CustomModalPlus isOpen={showPlusModal} onClose={closeModelPlus}
          image={modelImage}
          carousel={carousel}
          summaryParagraph={<p className={summaryParagraphStyles}>{summaryParagraph}</p>}
          isBorderNone={isBorderNone}
          highlightMsg={<p className={HeaderMsgStylesForPlus}> {headerMsg}</p>}
          subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
          btn1Exists={btn1Exists}
          btn2Exists={btn2Exists}
          btn1Text={btn1Text}
          btn1BgColor={btn1BgColor}
          btn2Text={btn2Text}
          opacityLow={opacityValueLow}
          defaultCornerRadius={false}
          btn1TypeAcpt={btn1TypeAcpt}
          onAcptBtnClick={onAcptBtnClickPlusModal}
          onCancelBtnClick={onCancelBtnClickPlusModal}
          gradientButton={gradientButton}
          largeImage={largeImage}
        />

          {activityDetected && (
                    <Modal
                      isOpen={activityDetected}
                      onClose={closeActivityDetectedModal}
                      defaultCornerRadius={false}
                      isLogo={false}
                      Fullheight={true}
                      title={<p className={HeadingUpdatedStyles}>
                        <span className={HeadingStyles}>
                            {
                                !isSuccess
                                    ? t('NTS_OOPS')
                                    : /\d/.test(displaySuccessMesg)
                                        ? ""
                                        : t('NTS_CONFIRMED')
                            }
                        </span>
                      </p>}
                      subHeaderMsg={
                        <span className={HeadingUpdatedStyles}>
                        {displaySuccessMesg}
                        </span>}
                      content={
                          <div className=' flex flex-col justify-center items-center w-full'>
                              <div className="flex flex-col gap-20 justify-center mb-[0px]">
                                  <div className="flex flex-col justify-center items-center w-full">

                                  </div>
                              </div>
                          {
                            !isSuccess ? (
                              <img
                                src={smiErrorImg}
                                alt="error"
                                className="lg:w-[150px] md:w-[100px] sm:w-[92px] w-[100px] lg:h-[150px] md:h-[100px] sm:h-[92px] h-[100px] lg:my-1 md:my-14 sm:my-10 my-10"
                              />
                            ) : /\d/.test(displaySuccessMesg) ? (
                              <div className="flex flex-col gap-20 justify-center mb-[100px]">
                                <div className="flex flex-col justify-center items-center w-full">

                                </div>
                              </div>
                            ) : (
                              <img
                                src={Dollor_Tick}
                                alt="complete"
                                className="lg:w-[150px] md:w-[100px] sm:w-[92px] w-[100px] lg:h-[150px] md:h-[100px] sm:h-[92px] h-[100px] lg:my-1 md:my-14 sm:my-10 my-10"
                              />
                            )
                          }
                              <div className=' flex flex-col justify-center items-center gap-8 w-full'>
                                  <button class="font-hanken-grotesk mt-[40px] lg:text-[18px] md:text-[17px] 
                                   sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full"
                                  onClick={backToHome}
                                  >Okay</button>
                              </div>
                          </div>
                      }
                    />
                  )}

            {errorModal && (
                <Modal
                    isOpen={errorModal}
                    onClose={closeErorModal}
                    defaultCornerRadius={false}
                    isLogo={false}
                    Fullheight={true}
                    title={<p className={HeadingUpdatedStyles}><span className={HeadingStyles}>Oops!</span></p>}
                    subHeaderMsg={
                        <span className={HeadingUpdatedStyles}>
                            {displayErrorMessage}
                        </span>}
                    content={
                        <div className=' flex flex-col justify-center items-center w-full'>
                            <div className="flex flex-col gap-20 justify-center mb-[20px]">
                                <div className="flex flex-col justify-center items-center w-full">

                                </div>
                            </div>
                            <img src={smiErrorImg} alt="complete" className='lg:w-[150px] md:w-[100px] sm:w-[92px] w-[100px] lg:h-[150px] md:h-[100px] sm:h-[92px] h-[100px] lg:my-1 md:my-14 sm:my-10 my-10' />
                            <div className=' flex flex-col justify-center items-center gap-8 w-full'>
                                <button class="font-hanken-grotesk mt-[40px] lg:text-[18px] md:text-[17px] 
                                   sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full"
                                onClick={backToHomeError}
                                >Okay</button>
                            </div>
                        </div>
                    }
                />
            )}

      {isLoading && <Loader />}
    </>
  );
};


export default HomeLayout;



